import { render, staticRenderFns } from "./ListReceipt.vue?vue&type=template&id=579b874d&scoped=true"
import script from "./ListReceipt.vue?vue&type=script&lang=ts"
export * from "./ListReceipt.vue?vue&type=script&lang=ts"
import style0 from "./ListReceipt.vue?vue&type=style&index=0&id=579b874d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b874d",
  null
  
)

export default component.exports